'use strict';

const keyboardNav = require('./headerKeyboardNav');
const countrySelectorKeyboardNav = require('./countrySelectorKeyboardNav');
const breakpoints = require('./breakpoints');
const rewardsTracker = require('./rewardsTracker');
// const _ = require('underscore');
const throttle = require('underscore').throttle;

const $sitenav = $('.sitenav');
const $agentForceMobileBtn = $('#agentForceChat_mobile_btn');

/**
 * Check if an element has a specific attribute
 * @param {string} attr The attribute name to check for
 * @returns {bool} True if the attribute exists, false otherwise
 */
$.fn.hasAttr = function (attr) {
    return this.attr(attr) !== undefined;
};

/**
 * Close Menu Plugin
 * @returns {jQuery} jQuery element reference
 */
$.fn.closeMenuItem = function () {
    if (breakpoints.isLowRes()) {
        // close tertiary menus (they're not toggled with an open class)
        this.find('[data-toggle=mobileCollapse][aria-expanded=true]').each(function () {
            if (this.mobileCollapse) {
                this.mobileCollapse.collapse();
            }
        });
    }

    // close any open child menus
    this.find('.open').removeClass('open');
    this.find('[aria-expanded]').attr('aria-expanded', 'false');

    // only set aria-expanded if value already exists
    if (this.hasAttr('aria-expanded')) {
        this.attr('aria-expanded', 'false');
    }

    this.removeClass('open');
    return this;
};

/**
 * Performs a slide up/down animation on the target element on mobile breakpoints.
 * Re-call this function when changing breakpoints.
 * @returns {jQuery} jQuery element reference
 */
$.fn.mobileCollapse = function () {
    if (breakpoints.isLowRes()) {
        $(this).off('.mobileCollapse').each(function () {
            const $trigger = $(this);
            const targetSelector = $trigger.data('target') || $trigger.attr('href');
            const $target = $(targetSelector);
            const transitionDuration = parseFloat($target.css('transition-duration')) || 350;

            // initally collapsed
            $trigger.attr('aria-expanded', 'false');
            $target.hide();

            /**
             * Expands the target element.
             * @param {bool} slide SlideDown or show instantly
             * @returns {jQuery} The target jQuery object
             * @example
             * let elemnt = $('[data-toggle=mobileCollapse]')[0]; // elmnt is NOT a jQuery object.
             * elemnt.mobileCollapse.expand(); // show instantly
             * // or elemnt.mobileCollapse.expand(true); // slide down
             */

            const _expand = function (slide) { // eslint-disable-line no-underscore-dangle
                $trigger.attr('aria-expanded', true);
                if (slide) return $target.slideDown(transitionDuration);
                return $target.show();
            };

            /**
             * Collapses the target element.
             * @param {bool} slide SlideUp or hide instantly
             * @returns {jQuery} The target jQuery object
             * @example
             * let elemnt = $('[data-toggle=mobileCollapse]')[0]; // elmnt is NOT a jQuery object.
             * elemnt.mobileCollapse.collapse(); // hide instantly
             * // or elemnt.mobileCollapse.collapse(true); // slide up
             */
            const _collapse = function (slide) { // eslint-disable-line no-underscore-dangle
                $trigger.attr('aria-expanded', 'false');
                if (slide) return $target.slideUp(transitionDuration);
                return $target.hide();
            };

            if ($target.length) {
                $trigger.on('click.mobileCollapse', function (e) {
                    if (this.tagName === 'A') {
                        e.preventDefault();
                    }

                    if ($target.css('display') === 'none') {
                        _expand(true);
                    } else {
                        _collapse(true);
                    }
                });
            }

            // the following object is attached to the trigger HTML element, not the jquery object,
            // so we can access its methods from outside this plugin without having to capture this jQuery object.
            this.mobileCollapse = {
                expand: _expand,
                collapse: _collapse
            };

            return this;
        });
    } else {
        // desktop - expand everything
        $(this).off('.mobileCollapse').attr('aria-expanded', true).each(function () {
            const targetSelector = $(this).data('target') || $(this).attr('href');
            const $target = $(targetSelector);

            $target.show();
        });
    }

    return this;
};

/**
 * If selected menu item has a submenu, show it
 * @param {string} selected - selected menu item
 * @returns {bool} if submenu exists
 */
function openSecondaryNav(selected) {
    // NOTE: This function is only invoked when a primary navigation item is clicked
    // this function is overridden in other brands
    const $primaryItem = $(selected);
    const $subNav = $primaryItem.siblings('.sitenav-secondary');

    if ($subNav.length) {
        // if there are secondary items, add the open class to .sitenav-secondary
        $primaryItem.parent('.sitenav-primary__li').attr('aria-expanded', true);
        $subNav.addClass('open').attr('aria-expanded', true);

        return true;
    }

    return false;
}

/**
 * Lazy Load Account Drawer Content
 */
function lazyLoadAccountContent() {
    let url = $('.js-action__menuopen, .js-action__menutoggle').data('lazy-load-menu-account-section-url');
    if (!url) {
        return;
    }

    let $container = $('.js-mobile-menu-account-drawer-container');

    // Exit early if the container is loading.
    if ($container.data('is-loading')) {
        return;
    }

    // Exit early if the content exists.
    if ($container.children().length) {
        return;
    }

    // Exit early if the container is loading.
    $container.data('is-loading', true);

    $.ajax({
        url: url,
        method: 'GET',
        success: function (response) {
            $container.append($(response));
            $container.on('click', '.js-btn-registration', function () {
                $container.find('.js-rewards-terms').prop('checked', !$(this).hasClass('js-btn-registration-no-rewards'));
            });
            rewardsTracker.loadRewardsTracker($('.account-content'));
            $container.find('form.login').trigger('form:created');
            $container.find('form.registration').trigger('form:created');
        },
        complete: function () {
            $container.data('is-loading', false);
        }
    });
}

/**
 * Close the mobile navigation menu
 */
function closeMobileNav() {
    $('.sitenav-secondary').closeMenuItem();
    $sitenav.closeMenuItem();
    $('html').removeClass('menu-active');
    $.enableScroll();
    $('body').off('click.breakpointDependent');
}

/**
 * Open the mobile navigation menu
 */
function openMobileNav() {
    lazyLoadAccountContent();

    // Prevent page scrolling
    $.disableScroll();
    $('html').addClass('menu-active');
    $sitenav.addClass('open');
    $(document).trigger('mobileMenu:show');

    // listen for clicks outside the menu
    $('body').on('click.breakpointDependent', function (e) {
        if (!$(e.target).closest('.sitenav').length) {
            closeMobileNav();
        }
    });
}

/**
 * Mouse events
 */
function mouseEvents() {
    // only for desktop

    if (breakpoints.isHighRes()) {
        $sitenav
            .on('mouseenter.breakpointDependent', '.sitenav-primary__li', function () {
                $(this).attr('aria-expanded', true);
            })
            .on('mouseleave.breakpointDependent', '.sitenav-primary__li', function () {
                $(this).attr('aria-expanded', false);
            });
    }

    // only for mobile
    if (breakpoints.isLowRes()) {
        // open menu
        $('.js-action__menuopen') // hamburger icon
            .on('click.breakpointDependent', function (e) {
                if ($sitenav.hasClass('open')) {
                    closeMobileNav();
                } else {
                    openMobileNav();
                }
                e.stopPropagation();
            });

        // open primary menu level
        $sitenav
            .on('click.breakpointDependent', '.sitenav-primary__a', function (e) {
                if (openSecondaryNav(this)) {
                    e.preventDefault();
                }
            });

        // mobile nav drawer close button
        $('.js-action__menuclose')
            .on('click.breakpointDependent', function () {
                closeMobileNav();
            });

        // mobile nav drawer back button on secondary menu
        $sitenav
            .on('click.breakpointDependent', '.js-action__menuback', function () {
                $(this).closest('.sitenav-primary__li').closeMenuItem();
            });
    }
}

/**
 * Keyboard events
 */
function keyboardEvents() {
    // Close menu when it loses focus
    $sitenav.on('focus', '*', function () {
        $sitenav.loseFocus(() => {
            $('.sitenav-primary__li.open').closeMenuItem();
        });
    });

    // on keyboard navigation focus
    if (breakpoints.isHighRes()) {
        $sitenav
            .on('focus', '.sitenav-primary__li', function () {
                $(this).attr('aria-expanded', true);
            });
    }
}

/**
 * Miscellaneous events
 */
function miscEvents() {
    // There are "Sign In" links in checkout that need to trigger the account menu to open...
    $('.js-action__account-open').on('click', function (e) {
        const hasAccountIcon = $('.js-action__account').length;
        const $siteHeaderAccount = $('.siteheader .siteheader__account-link');
        if (hasAccountIcon) {
            e.preventDefault();
            e.stopPropagation();

            if (breakpoints.isLowRes()) {
                const loginPage = $siteHeaderAccount.find('.js-action__account').attr('href');
                if (loginPage !== '') {
                    window.location.replace(loginPage);
                }
            } else {
                $(document).trigger('accountDrawer:show');
            }
        }
    });
}

/**
 * Determines if the window is scrolled
 */
function windowIsScrolled() {
    const isScrolled = $(window).scrollTop() > 0;
    $('body').toggleClass('window-is-scrolled', isScrolled);
}

/**
 * Events triggered on page scroll
 */
function scrollEvents() {
    const windowIsScrolledDebounce = throttle(windowIsScrolled, 50);

    /**
     * Passive event listeners improve scrolling performance: https://web.dev/uses-passive-event-listeners/
     * All our supported browsers support passive listeners: https://caniuse.com/passive-event-listener
     * JQuery will not support passive scroll listeners until v4 (in development): https://github.com/jquery/jquery/issues/2871
     */
    document.addEventListener('scroll', windowIsScrolledDebounce, { passive: true });
}

/**
 * Events triggered on screen size
 */
function resizeEvents() {
    // 'breakpoint:changed' event is fired from jquery.cscutils.js on page load and when resizing from one breakpoint to another
    $(window).on('breakpoint:changed', function (e, data) {
        // clear all breakpoint dependent events
        $('*').off('.breakpointDependent');
        mouseEvents();
        miscEvents();

        if (data.currentBp === 'lg' || data.currentBp === 'xl' || data.currentBp === '2xl') {
            closeMobileNav();
        }

        $('[data-toggle="mobileCollapse"]').mobileCollapse();
    });

    $('[data-toggle="mobileCollapse"]').mobileCollapse();
}

/**
 * Initialize functions
 */
function init() {
    mouseEvents();
    keyboardEvents();
    keyboardNav.init();
    countrySelectorKeyboardNav.init();
    miscEvents();
    scrollEvents();
    resizeEvents();
}

function launchChat() {
    function handleError(error) {
        console.error('Chat launch error:', error);
    }
    try {
        if (!window.embeddedservice_bootstrap || !window.embeddedservice_bootstrap.utilAPI) {
            throw new Error('Embedded service not loaded or utilAPI not available.');
        }
        window.embeddedservice_bootstrap.utilAPI.launchChat().catch(handleError);
    } catch (err) {
        handleError(err);
    }
}

if ($agentForceMobileBtn) {
    $agentForceMobileBtn.on('click', launchChat);
}

module.exports = function () {
    init();
};
